var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFound)?_c('span',{staticClass:"cd"}):_c('div',{staticClass:"cd"},[_c('strong',[_vm._v(_vm._s(_vm.args.dirname))]),_vm._v(" is not a valid directory. ")])}
var staticRenderFns = []

export { render, staticRenderFns }